/**
 * Returns a promise that resolves after `ms` milliseconds or immediately if
 * the AbortSignal fires first.
 */
export function delay(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const settle = () => {
      if (settled) {
        return;
      }
      settled = true;
      resolve();
    };

    // Declare before onAbort to avoid TDZ crash if abort fires between
    // addEventListener and the setTimeout assignment.
    let timer: ReturnType<typeof setTimeout> | undefined;

    const onAbort = () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
      settle();
    };

    // Register handler before timeout so aborts between the guard and
    // addEventListener cannot be missed.
    signal.addEventListener("abort", onAbort, { once: true });

    if (signal.aborted) {
      signal.removeEventListener("abort", onAbort);
      settle();
      return;
    }

    timer = setTimeout(() => {
      signal.removeEventListener("abort", onAbort);
      settle();
    }, ms);
  });
}
